function PrivacyNL() {
  return (
    <div className="bg-primary">
      <h1 className="text-3xl font-bold mb-4">Privacybeleid</h1>
      <p className="mb-4 text-secondary">
        Dit privacybeleid is van toepassing op de website{" "}
        <a href="https://next.martvanweeghel.nl" className="text-[#4ab6c6]">
          https://next.martvanweeghel.nl
        </a>{" "}
        en het gebruik van het contactformulier dat wordt aangeboden door Next
        Generation (hierna "wij", "ons" of "onze").
      </p>

      <p className="mb-4 text-secondary">
        Wij hechten veel waarde aan de privacy van onze gebruikers. Dit
        privacybeleid beschrijft hoe we het e-mailadres verzamelen dat je
        verstrekt via het contactformulier, hoe we het gebruiken en hoe we het
        beschermen. Door gebruik te maken van ons contactformulier stem je in
        met de voorwaarden van dit privacybeleid.
      </p>

      <h2 className="text-xl font-bold mb-2">Verzamelde informatie</h2>
      <ul className="list-disc list-inside mb-4 text-secondary">
        <li>
          E-mailadres: Wanneer je het contactformulier op onze website invult,
          verzamelen we het e-mailadres dat je opgeeft.
        </li>
      </ul>

      <h2 className="text-xl font-bold mb-2">Gebruik van informatie</h2>
      <p className="mb-4 text-secondary">
        We gebruiken het verzamelde e-mailadres alleen om te reageren op je
        vraag of opmerking die je hebt ingediend via het contactformulier. We
        gebruiken het e-mailadres niet voor andere doeleinden, zoals
        marketingmails, zonder je uitdrukkelijke toestemming.
      </p>

      <h2 className="text-xl font-bold mb-2">Delen van informatie</h2>
      <p className="mb-4 text-secondary">
        We delen het verzamelde e-mailadres niet met derden, tenzij dit
        wettelijk vereist is.
      </p>

      <h2 className="text-xl font-bold mb-2">Beveiliging van informatie</h2>
      <p className="mb-4 text-secondary">
        We nemen passende maatregelen om het e-mailadres dat je via het
        contactformulier verstrekt te beschermen tegen ongeoorloofde toegang,
        wijziging, openbaarmaking of vernietiging.
      </p>

      <h2 className="text-xl font-bold mb-2">Links naar andere sites</h2>
      <p className="mb-4 text-secondary">
        Onze website kan links bevatten naar andere sites die niet door ons
        worden beheerd. Als je op een link van een derde partij klikt, word je
        naar de site van die derde partij geleid. We raden je ten zeerste aan om
        het privacybeleid van elke site die je bezoekt te lezen.
      </p>

      <h2 className="text-xl font-bold mb-2">
        Wijzigingen in dit privacybeleid
      </h2>
      <p className="mb-4 text-secondary">
        We kunnen ons privacybeleid van tijd tot tijd bijwerken. We zullen je op
        de hoogte stellen van eventuele wijzigingen door het nieuwe
        privacybeleid op deze pagina te plaatsen. Het is raadzaam dit
        privacybeleid regelmatig te controleren op eventuele wijzigingen.
        Wijzigingen in dit privacybeleid zijn van kracht wanneer ze op deze
        pagina worden geplaatst.
      </p>

      <h2 className="text-xl font-bold mb-2">Contact met ons opnemen</h2>
      <p className="text-secondary">
        Als je vragen hebt over dit privacybeleid, neem dan contact met ons op
        via{" "}
        <a href="mailto:next@martvanweeghel.nl" className="text-[#4ab6c6]">
          next@martvanweeghel.nl
        </a>
        .
      </p>
    </div>
  );
}

export default PrivacyNL;
